import { Injectable } from "@angular/core";
import { VeiculoEquipamentoController } from "app/controllers/mob/veiculo-equipamento.controller";
import { VeiculoEquipamentoTableListDTO } from 'app/model/dtos/mob/veiculo-equipamento-table-dto';
import { VeiculoEquipamentoDTO } from "app/model/dtos/mob/veiculo-equipamento.dto";
import { EquipamentoSearch } from 'app/services/grl/equipamento.search';
import { LoaderService } from "../loader.service";

@Injectable({
  providedIn: "root",
})
export class VeiculoEquipamentoService {
  
  constructor(
    private _veiculoEquipamentoController: VeiculoEquipamentoController,
    private _loaderService: LoaderService
  ) {}

  async getEquipamento(cdEquipamento: number, cdVeiculo: number): Promise<VeiculoEquipamentoDTO> {
    this._loaderService.show();
    return this._veiculoEquipamentoController.getEquipamento(cdEquipamento, cdVeiculo).finally(() => this._loaderService.hide());
  }

  async getEquipamentoById(idEquipamento: string): Promise<VeiculoEquipamentoDTO> {
    this._loaderService.show();
    return this._veiculoEquipamentoController.getEquipamentoById(idEquipamento).finally(() => this._loaderService.hide());
  }

  async transferirEquipamento(veiculoEquipamentoDTO: VeiculoEquipamentoDTO): Promise<VeiculoEquipamentoDTO> {
    this._loaderService.show();
    return this._veiculoEquipamentoController.transferirEquipamento(veiculoEquipamentoDTO).finally(() => this._loaderService.hide());
  }

  async saveEquipamento(veiculoEquipamentoDTO: VeiculoEquipamentoDTO): Promise<VeiculoEquipamentoDTO> {
    this._loaderService.show();
    if (veiculoEquipamentoDTO.cdInstalacao > 0) {
        return this._veiculoEquipamentoController.updateEquipamento(veiculoEquipamentoDTO).finally(() => this._loaderService.hide());
    } else {
        return this._veiculoEquipamentoController.createEquipamento(veiculoEquipamentoDTO).finally(() => this._loaderService.hide());
    }
  }

  async pagedFind(equipamentoSearch: EquipamentoSearch): Promise<VeiculoEquipamentoTableListDTO>{
    this._loaderService.show();
    return this._veiculoEquipamentoController.pagedFind(equipamentoSearch && equipamentoSearch.getFilters() || null).finally(() => this._loaderService.hide());
  }
  
}
